import { Component, OnInit } from '@angular/core';
import { ProDevService } from '../../service/pro-dev.service';
import { PersonService } from '../../service/person.service';

@Component({
  	selector: 'app-questions',
  	templateUrl: './questions.component.html',
	styleUrls: [
		'./questions.component.styl',
		'../../share/modal/modal.component.styl',
		'../../share/breadcrumb/breadcrumb.component.styl',
	]
})
export class QuestionsComponent implements OnInit{
	questionList: any = [];
	page: any = { // 当前页数和总页数
		pageIndex: 1,
		pageCount: 1,
	};
	isModalShow: boolean = false;
	isTipShow: boolean = false;
	question: string;
	loginModal: any = { // 登录弹窗
		title: 'CHINAICAC MEMBER SIGN IN',
        isSigninShow: false,
        closeShow: false,
	};
	
	constructor(
		private prodevService: ProDevService,
		private personService: PersonService
	){}
	
	// 初始化
	ngOnInit(){
		this.getQuestionList();	
	}

	// 获取问答列表
	getQuestionList(pageIndex = 1){
		this.page.pageIndex = pageIndex;
		this.prodevService.getQuestions(pageIndex).subscribe(res => {
			if (res.status === 200){
				this.questionList = res.rows || [];
				this.page.pageCount = Math.ceil(res.total / 10);
			}
		});
	}
	
	// 页码点击事件
	onShowPage(page: number){
		this.getQuestionList(page);
	}

	// 提问
	askQuestion(){
		this.personService.getUserInfo().subscribe(res => {
			if (res.ok){
				this.isModalShow = true;
			}else{
				this.loginModal.isSigninShow = true;
			}
		});
	}

	// 提交问题
	submit(){
		if (!this.question || !this.question.trim()){
			this.isTipShow = true;
			return;
		}
		this.prodevService.postQuestion(this.question).subscribe(res => {
			if (res.status === 200){
				this.isModalShow = false;
				this.getQuestionList(1);
			}
		});
	}

	// 登录回调
	loginEmit(){
		this.loginModal.isSigninShow = false;
	}
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/professional-dev/questions/questions.component.ts